/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VendorErrorCodeManufacturerSummaryDto
 */
export interface VendorErrorCodeManufacturerSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeManufacturerSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof VendorErrorCodeManufacturerSummaryDto
     */
    name: string;
}

/**
 * Check if a given object implements the VendorErrorCodeManufacturerSummaryDto interface.
 */
export function instanceOfVendorErrorCodeManufacturerSummaryDto(value: object): value is VendorErrorCodeManufacturerSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function VendorErrorCodeManufacturerSummaryDtoFromJSON(json: any): VendorErrorCodeManufacturerSummaryDto {
    return VendorErrorCodeManufacturerSummaryDtoFromJSONTyped(json, false);
}

export function VendorErrorCodeManufacturerSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorCodeManufacturerSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function VendorErrorCodeManufacturerSummaryDtoToJSON(json: any): VendorErrorCodeManufacturerSummaryDto {
    return VendorErrorCodeManufacturerSummaryDtoToJSONTyped(json, false);
}

export function VendorErrorCodeManufacturerSummaryDtoToJSONTyped(value?: VendorErrorCodeManufacturerSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

